module.exports = __webpack_public_path__ + "media/images/countryrect/pe-05f5fa0ecb8b0d47abe04afd0746a3b7.svg";